<div class="row mt-5">
  <div class="col-12">
    <h4 id="conditions-applications-article-84-1">Conditions d’application de l’article 84.1 LIR</h4>
    <!-- areTransferredSharesCanadianShares -->
    <magieno-boolean-select
    [advancedFormControl]="this.areTransferredSharesCanadianShares"></magieno-boolean-select>

    <!-- areTransferredSharesCapitalPropertyForTheSeller -->
    <magieno-boolean-select
    [advancedFormControl]="this.areTransferredSharesCapitalPropertyForTheSeller"></magieno-boolean-select>

    <!-- isSellerAnIndividualOrATrust -->
    <magieno-boolean-select
    [advancedFormControl]="this.isSellerAnIndividualOrATrust"></magieno-boolean-select>

    <!-- isSellerACanadianResident -->
    <magieno-boolean-select
    [advancedFormControl]="this.isSellerACanadianResident"></magieno-boolean-select>

    <!-- isBuyerACorporation -->
    <magieno-boolean-select
    [advancedFormControl]="this.isBuyerACorporation"></magieno-boolean-select>

    <!-- areBuyerAndSellerAtArmsLength -->
    <magieno-boolean-select
    [advancedFormControl]="this.areBuyerAndSellerAtArmsLength"></magieno-boolean-select>

    <!-- isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction -->
    <magieno-boolean-select
    [advancedFormControl]="this.isCorporationForWhichSharesAreBeingSoldBecomingAtArmsLengthImmediatelyAfterTransaction"></magieno-boolean-select>
  </div>
</div> <!-- / .row -->


<div class="row">
  <div class="col-12">
    <h4 class="mt-5">
      Informations si application de l’article 84.1 LIR
    </h4>

    <!--            <div #collapseSection84_1Applicable="ngbCollapse" [(ngbCollapse)]="isSection84_1Collapsed">-->
    <div class="card ">
      <div class="card-body pb-5" style="position: relative;">
        @if (isSection84_1Applicable) {
          <div class="alert alert-warning" role="alert">
            <i class="fas fa-exclamation-triangle"></i> Attention! L’article 84.1 L.I.R.
            s’applique à cette transaction donc vous devez remplir le formulaire additionnel.
          </div>
        }

        @if (isSection84_1Applicable === false) {
          <div class="alert alert-light" role="alert">
            <i class="fas fa-exclamation-triangle"></i> L’article 84.1 L.I.R. ne s’applique pas
            à cette transaction donc vous n'avez pas à rentrer les informations ci-dessous.
          </div>
        }

        <div class="text-center" style="position: absolute; bottom: 10px; width: 100%;">
          <button (click)="collapseSection84_1Applicable.toggle()"
            class="shadow btn btn-link btn-outline-light rounded-pill"
            style="">
            @if (isSection84_1Collapsed) {
              <span><i class="fas fa-angle-double-down"></i> Agrandir</span>
            }
            @if (!isSection84_1Collapsed) {
              <span><i class="fas fa-angle-double-up"></i> Réduire</span>
            }
          </button>
        </div>


        <div #collapseSection84_1Applicable="ngbCollapse" [(ngbCollapse)]="isSection84_1Collapsed" class="row">
          <div class="col-12">

            <!-- capitalGainsOnTheShareDeclaredAfter1984 -->
            <magieno-input-money-field [advancedFormControl]="this.capitalGainsOnTheShareDeclaredAfter1984"
              [currency]="this.currency"
            [locale]="this.locale"></magieno-input-money-field>


            <!-- sellingFees -->
            <magieno-input-money-field [advancedFormControl]="this.sellingFees"
              [currency]="this.currency"
            [locale]="this.locale"></magieno-input-money-field>

            <!-- wereSharesAcquiredAfter1971 -->
            <magieno-boolean-select
            [advancedFormControl]="this.wereSharesAcquiredAfter1971"></magieno-boolean-select>


            @if (this.form.value.wereSharesAcquiredAfter1971 === false) {
              <div
                class="card">
                <div class="card-body">
                  <div class="row">
                    <!-- fairMarketValueOnValuationDayOfTransferredShares -->
                    <magieno-input-money-field [advancedFormControl]="this.fairMarketValueOnValuationDayOfTransferredShares"
                      [currency]="this.currency"
                    [locale]="this.locale"></magieno-input-money-field>
                    <!-- actualCostOnJanuary1972OfTransferredShares -->
                    <magieno-input-money-field [advancedFormControl]="this.actualCostOnJanuary1972OfTransferredShares"
                      [currency]="this.currency"
                    [locale]="this.locale"></magieno-input-money-field>
                    <!-- receivedDividendChoice83OnTransferredShares -->
                    <magieno-input-money-field [advancedFormControl]="this.receivedDividendChoice83OnTransferredShares"
                      [currency]="this.currency"
                    [locale]="this.locale"></magieno-input-money-field>
                  </div>
                </div>
              </div>
            }
          </div>
        </div> <!-- / .row -->
      </div>
    <!--                </div>-->
  </div>
</div>
</div>